module.exports = __webpack_public_path__ + "img/sepa.ccd8152a.png";